import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@blade/common/store/app';
import SidebarItem from './sidebar-item.vue';
import { LoginModule } from '@blade/common/store/login';
import { toLower } from 'lodash';
import Hamburger from '@/router/components/layout/components/navbar/hamburger.vue';
import config from './config';
import lang from '@/router/lang/sidebar';
let default_1 = class default_1 extends Vue {
    // 临时为新洲之窗项目疲敝排队及1.3的功能。
    sideBar = config;
    activeIndex = '';
    defaultLogoUrl = '';
    thumbnailUrl = '';
    get layoutPermissions() {
        return LoginModule.permissions;
    }
    initNav() {
        const defaultPath = this.sideBar.filter((i) => !i.hidden)?.[0]?.path;
        const routePath = this.$route.path;
        const isPath = routePath === '/';
        if (isPath || !routePath) {
            defaultPath && this.$router.push(defaultPath);
        }
    }
    mounted() {
        this.initNav();
        this.activeMenu();
        try {
            if (LoginModule.logoConfig.systemName !== '' ||
                LoginModule.logoConfig.defaultLogoUrl !== '' ||
                LoginModule.logoConfig.menuShrinkageLogoUrl !== '') {
                this.defaultLogoUrl = LoginModule.logoConfig?.defaultLogoUrl;
                this.thumbnailUrl = LoginModule.logoConfig?.menuShrinkageLogoUrl;
            }
        }
        catch (e) { }
    }
    get isCollapse() {
        return !AppModule.sidebar.opened;
    }
    activeMenu() {
        const res = this.$route.path;
        const currSidebar = [];
        this.findActive(this.sideBar, currSidebar, res);
        currSidebar.sort(function (a, b) {
            return b.path.length - a.path.length;
        });
        this.activeIndex = currSidebar.length > 0 ? currSidebar[0].index : '0-01';
    }
    findActive(sideBar, currSidebar, path) {
        const toLowerPath = toLower(path);
        sideBar.forEach((item) => {
            const itemPath = toLower(item.path);
            if (itemPath === toLowerPath || toLowerPath.indexOf(itemPath) >= 0) {
                currSidebar.push({ index: item.index, path: item.path });
            }
            if (item.children && item.children.length > 0) {
                this.findActive(item.children, currSidebar, toLowerPath);
            }
        });
    }
    onRouteChange() {
        this.activeMenu();
    }
    onPermissionChange(newVal) {
        const res = new Map();
        this.flattenPermissions(newVal, res);
        const copyedSideBar = JSON.parse(JSON.stringify(this.sideBar));
        this.traverseTree(copyedSideBar, res);
        this.sideBar = [...copyedSideBar];
    }
    flattenPermissions(permissions, flattenPermissions) {
        permissions.forEach((item) => {
            // 2.1.3此处获取enable的逻辑变化 由guest admin system控制有一个为true则放开入口
            flattenPermissions.set(item.code, item.enable);
            if (item.subPermissions?.length > 0) {
                this.flattenPermissions(item.subPermissions, flattenPermissions);
            }
        });
    }
    traverseTree(sideBar, flattenPermissions) {
        for (let i = 0; i < sideBar.length; i++) {
            const currBar = sideBar[i];
            const currPerm = flattenPermissions.get(currBar.code || ''); // undefined or enable is false hide
            currBar.hidden = !currPerm;
            this.traverseTree(currBar.children || [], flattenPermissions);
        }
    }
    get sidebar() {
        return AppModule.sidebar;
    }
};
__decorate([
    Watch('$route')
], default_1.prototype, "onRouteChange", null);
__decorate([
    Watch('layoutPermissions', { deep: true, immediate: true })
], default_1.prototype, "onPermissionChange", null);
default_1 = __decorate([
    Component({
        name: 'SideBar',
        components: {
            SidebarItem,
            Hamburger,
        },
        i18n: {
            messages: lang,
        },
    })
], default_1);
export default default_1;
